// 생기부 "내 스타일" 적용 여부 판정 — 백엔드 판정과 같은 규칙을 한 곳에 둔다.
//  * profile_has_content (saenggibu_style_service.py): style_spec / rule_summary / instructions
//    또는 참고 예시(examples)가 하나라도 있으면 "내용 있음".
//  * get_active_profiles_for_generation: 공통(global) + 생성하는 종류(category) 프로필만 적용.

const hasExamples = (profile) => {
  if (Array.isArray(profile.examples) && profile.examples.length > 0) return true;
  return Number(profile.examples_count) > 0;
};

// 프로필 하나에 생성에 쓸 내용이 있는지 (버튼 상태·유도 문구·설정 화면 공용)
export const hasStyleProfileContent = (profile) => Boolean(
  profile
  && typeof profile === 'object'
  && profile.enabled !== false
  && (
    (profile.style_spec && Object.keys(profile.style_spec).length > 0)
    || (Array.isArray(profile.rule_summary) && profile.rule_summary.length > 0)
    || String(profile.instructions || '').trim()
    || hasExamples(profile)
  )
);

// 특정 종류로 생성할 때 서버가 실제로 스타일을 붙이는지: 공통 또는 그 종류의 프로필에 내용이 있어야 한다.
// (종류가 비어 있거나 스타일 스코프가 아닌 값(예: 비슷한문장)이면 공통 프로필만 본다 — 백엔드와 동일)
export const isMyStyleActiveForCategory = (profiles, category) => {
  const map = profiles && typeof profiles === 'object' ? profiles : {};
  if (hasStyleProfileContent(map.global)) return true;
  return Boolean(category) && hasStyleProfileContent(map[category]);
};

// 어떤 종류든 하나라도 내용 있는 프로필이 있는지 (마스터 토글 노출 여부)
export const hasAnyStyleProfileContent = (profiles) => (
  Object.values(profiles && typeof profiles === 'object' ? profiles : {}).some(hasStyleProfileContent)
);
